import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { messaging } from "config/firebase";
import { isShowRvRating } from "store/actions/AvRatingAction";
import {
  updateImg,
  refreshAuth,
  updateQrCode,
  updateInfo,
} from "store/actions/authActions";
import {
  fetchSchoolStates,
  getCollegeCity,
  getSchoolCounty,
  fetchStates,
} from "store/actions/athleteActions";
import {
  getMatchSchoolContract,
  addSchoolContract,
  getSchoolAdminData,
} from "store/actions/requestSchoolContractsAction";
import { newCollegeUniversities } from "store/actions/newCollegeUniversities";
import { newSchoolsData } from "store/actions/newSchoolsAction";
import { getAllUsers } from "store/actions/userAction";
import { getSports } from "store/actions/sportAction";
import { updateUserDeviceToken } from "store/actions/notificationAction";

export const useProfileData = () => {
  const dispatch = useDispatch();

  const { user, uid, imgLoading, qrCodeLoading } = useSelector(
    (state) => state.auth
  );
  const { schoolStates, states, cities, counties } = useSelector(
    (state) => state.athlete
  );
  const { sports } = useSelector((state) => state.sport);
  const { existSchoolContractCid, schoolAdminData } = useSelector(
    (state) => state.contract
  );
  const { newCollegeUniversitiesData } = useSelector(
    (state) => state.collegeAndUniversities
  );
  const { newSchoolsAllData } = useSelector((state) => state.schools);

  const [youtubeURL, setYoutubeURL] = useState(user?.youtube_url || "");
  const [firstName, setFirstName] = useState(user?.first_name || "");
  const [lastName, setLastName] = useState(user?.last_name || "");
  const [state, setState] = useState(user?.state || "");
  const [sport, setSport] = useState(user?.sport || "");
  const [chatRate, setChatRate] = useState(user?.chatRate || "");
  const [sportBadgeRate, setSportBadgeRate] = useState(
    user?.sportBadgeRate || ""
  );
  const [qrUrl, setQrUrl] = useState(user?.Qr_Url || "");
  const [image, setImage] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [rvLoader, setRvLoader] = useState(false);
  const [BtnLoader, setBtnLoader] = useState(false);
  const [contractQuestion, setContractQuestion] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [school, setSchool] = useState(user?.institute_name || "");
  const [city, setCity] = useState(user?.city || "");

  // Biography & PayPal Email states
  const [biography, setBiography] = useState(user?.biography || "");
  const [paypalEmail, setPaypalEmail] = useState(user?.paypal_email || "");

  // Personal Info Edit state
  const [isEditingPersonal, setIsEditingPersonal] = useState(false);
  const [personalSaveLoader, setPersonalSaveLoader] = useState(false);

  const [fields, setFields] = useState({
    nameEdit: false,
    lastNameEdit: false,
    chatRateEdit: false,
    sportLevelEdit: false,
    cityEdit: false,
    youtubeEdit: false,
    sportEdit: false,
    stateEdit: false,
    collegeEdit: false,
    sportBadgeEdit: false,
    qrUrlEdit: false,
  });

  const [modals, setModals] = useState({
    promote: false,
    postWarning: false,
    AthleteInstructions: false,
  });

  const handleNoContract = () => {
    setContractQuestion(false);
  };

  const modalToggle = (name) => {
    let newModal = JSON.parse(JSON.stringify(modals));
    for (let modal of Object.keys(newModal)) {
      if (modal !== name) newModal[modal] = false;
    }
    newModal[name] = !newModal[name];
    setModals(newModal);
  };

  const handleContract = () => {
    setBtnLoader(true);
    let obj = {
      uid,
      schoolAdminId: existSchoolContractCid,
    };
    dispatch(
      addSchoolContract(obj, () => {
        dispatch(getSchoolAdminData(existSchoolContractCid));
        dispatch(refreshAuth(uid));
        setBtnLoader(false);
      })
    );
  };

  const handleToggle = (prop) => {
    setRvLoader(true);
    let data = {
      id: uid,
      isShowRvRating: !prop,
    };
    dispatch(
      isShowRvRating(data, () => {
        dispatch(
          refreshAuth(uid, () => {
            setRvLoader(false);
          })
        );
      })
    );
  };

  const fieldToggle = (field) => {
    setFields((prevState) => ({ ...prevState, [field]: !prevState[field] }));
  };

  useEffect(() => {
    if (user?.schoolAdminId) {
      dispatch(getSchoolAdminData(user?.schoolAdminId));
    }
  }, [user?.schoolAdminId, dispatch]);

  useEffect(() => {
    if (state) {
      if (user?.sportLevel === "College athlete") {
        dispatch(getCollegeCity(state));
      } else {
        dispatch(getSchoolCounty(state));
      }
    }
  }, [state, user?.sportLevel, dispatch]);

  useEffect(() => {
    let obj = {
      state: user?.state,
      county: user?.city,
      school: user?.institute_name,
    };
    dispatch(getSports());
    dispatch(getMatchSchoolContract(obj));
    if (states.length === 0) {
      dispatch(fetchStates());
    }
    if (schoolStates.length === 0) {
      dispatch(fetchSchoolStates());
    }
  }, [user?.institute_name, user?.state, user?.city, states.length, schoolStates.length, dispatch]);

  useEffect(() => {
    if (state !== "" && city !== "") {
      if (user?.sportLevel === "College athlete") {
        dispatch(newCollegeUniversities(state, city));
      } else {
        dispatch(newSchoolsData(state, city));
      }
    }
  }, [state, city, user?.sportLevel, dispatch]);

  let newSchools = [];
  const getInstitutes = () => {
    if (user?.sportLevel === "College athlete") {
      newCollegeUniversitiesData.forEach((insti) => {
        if (Array.isArray(insti.institutes)) {
          insti.institutes.forEach((ele) => {
            newSchools.push(ele);
          });
        }
      });
    } else {
      newSchoolsAllData.forEach((insti) => {
        insti.institutes?.forEach((ele) => {
          newSchools.push(ele);
        });
      });
    }
    return newSchools;
  };

  const defaultStateProps = {
    options:
      user?.sportLevel === "College athlete"
        ? states?.map((insti) => insti.name) || []
        : [...(schoolStates?.map((insti) => insti.name) || []), "OTHER"].sort(),
    getOptionLabel: (option) => option,
  };

  const defaultCityProps = {
    options:
      user?.sportLevel === "College athlete"
        ? [...(cities?.map((insti) => insti.city) || []), "OTHER"].sort()
        : [...(counties?.map((insti) => insti.county) || []), "OTHER"].sort(),
    getOptionLabel: (option) => option,
  };

  const defaultSportProps = {
    options:
      sports.length > 0
        ? sports.map((item) => item.sport)
        : [],
    getOptionLabel: (option) => option,
  };

  const defaultNewSchoolProps = {
    options: getInstitutes(),
    getOptionLabel: (option) => option,
  };

  const handleChangeAddress = (e) => {
    e.preventDefault();
    let obj = {
      city: city,
      state: state,
      institute_name: school,
    };
    setEditLoader(true);
    dispatch(updateInfo(uid, obj, "address")).then(() => {
      setEditLoader(false);
      setIsEdit(false);
    });
  };

  const handleSavePersonalInfo = async (e) => {
    e.preventDefault();
    if (!firstName || !firstName.trim()) {
      toast.error("First Name is required.");
      return;
    }
    if (!lastName || !lastName.trim()) {
      toast.error("Last Name is required.");
      return;
    }
    if (!biography || !biography.trim()) {
      toast.error("Biography is required.");
      return;
    }
    const updates = {};
    if (firstName !== user?.first_name) {
      updates.first_name = firstName.trim();
    }
    if (lastName !== user?.last_name) {
      updates.last_name = lastName.trim();
    }
    if (biography !== user?.biography) {
      updates.biography = biography.trim();
    }

    if (Object.keys(updates).length > 0) {
      setPersonalSaveLoader(true);
      try {
        await dispatch(updateInfo(uid, updates, "profile_fields"));
        setIsEditingPersonal(false);
      } catch (err) {
        console.error("Failed to update personal info:", err);
        toast.error("Failed to update personal info.");
      } finally {
        setPersonalSaveLoader(false);
      }
    } else {
      setIsEditingPersonal(false);
    }
  };

  // Setup device tokens for notification
  const createToken = async (currentUser, currentDispatch) => {
    try {
      await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      const registration = await navigator.serviceWorker.ready;
      const currentToken = await messaging.getToken({
        vapidKey:
          "BKtBn0Hxuy7MmztJf28DCm_M5M3sygGUP4F5QESuGUo4toV1fS2-Ex-h_8EWhXbO1ze3g9yiLDK-mo105WcNhIM",
        serviceWorkerRegistration: registration,
      });

      if (currentToken) {
        if (!currentUser?.fcmToken || currentUser.fcmToken !== currentToken) {
          currentDispatch(updateUserDeviceToken(currentToken, currentUser.id));
        }
      }
    } catch (err) {
      console.error("Error retrieving FCM token: ", err);
    }
  };

  const requestNotificationPermission = async (currentUser, currentDispatch) => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        await createToken(currentUser, currentDispatch);
      }
    } catch (error) {
      console.error("Error requesting notification permission:", error);
    }
  };

  useEffect(() => {
    if (!user) {
      dispatch(getAllUsers());
    }
    const initializeNotifications = async () => {
      if (!("Notification" in window) || !navigator.serviceWorker || !user) {
        return;
      }
      if (Notification.permission === "granted") {
        await createToken(user, dispatch);
      } else if (Notification.permission === "default") {
        await requestNotificationPermission(user, dispatch);
      } else {
        console.error("Notifications previously denied by user");
      }
    };

    initializeNotifications();
  }, [user, dispatch]);

  return {
    dispatch,
    user,
    uid,
    imgLoading,
    qrCodeLoading,
    youtubeURL,
    setYoutubeURL,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    state,
    setState,
    sport,
    setSport,
    chatRate,
    setChatRate,
    sportBadgeRate,
    setSportBadgeRate,
    qrUrl,
    setQrUrl,
    image,
    setImage,
    qrCode,
    setQrCode,
    rvLoader,
    BtnLoader,
    contractQuestion,
    isEdit,
    setIsEdit,
    editLoader,
    school,
    setSchool,
    city,
    setCity,
    fields,
    modals,
    handleNoContract,
    handleContract,
    handleToggle,
    fieldToggle,
    modalToggle,
    handleChangeAddress,
    isEditingPersonal,
    setIsEditingPersonal,
    personalSaveLoader,
    handleSavePersonalInfo,
    defaultStateProps,
    defaultCityProps,
    defaultSportProps,
    defaultNewSchoolProps,
    existSchoolContractCid,
    schoolAdminData,
    biography,
    setBiography,
    paypalEmail,
    setPaypalEmail,
  };
};
